import { formatUserDate, formatUserDateTime } from "owa-datetime-formatters";
import { parseFlagDate } from "owa-mail-list-store";

const MIN_WIDTH_FOR_DATE_AND_TIME_PX = 109;
/**
 * Formats a flag due date ISO string to a user-friendly date string.
 * @param flagDueDate - ISO date string like "2026-02-06T21:30:00Z"
 * @returns Formatted date string like "2/6/2026" or "2/6/2026 9:30 PM" (based on user's locale and available width)
 */
export default function formatFlagDueDate(flagDueDate: string | null | undefined, flagDueDateColumnWidth: number): string {
    if (!flagDueDate) {
        return "--";
    }
    const parsedDueDate = parseFlagDate(flagDueDate);
    if (flagDueDateColumnWidth < MIN_WIDTH_FOR_DATE_AND_TIME_PX) {
        return formatUserDate(parsedDueDate);
    }
    return formatUserDateTime(parsedDueDate);
}
